import { render, staticRenderFns } from "./ManageShorthand.vue?vue&type=template&id=d4a3b590"
import script from "./ManageShorthand.vue?vue&type=script&lang=js"
export * from "./ManageShorthand.vue?vue&type=script&lang=js"
import style0 from "./ManageShorthand.vue?vue&type=style&index=0&id=d4a3b590&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports